<script lang="ts" setup>
import { watch } from 'vue'
import { POP_TYPE } from '@/constants'

const props = withDefaults(defineProps<{
  value: boolean
  mask?: boolean
  closable?: boolean
  popType?: number
}>(), {
  mask: true,
  closable: true,
})

const emit = defineEmits<{
  (event: 'input', value: boolean): void
  (event: 'open'): void
  (event: 'close'): void
}>()

watch(() => props.value, (value) => {
  value ? emit('open') : emit('close')
})
</script>

<template>
  <div to="root relative w-100wv h-100vh">
    <transition name="fade">
      <div
        v-if="value && mask" class="fixed inset-0 bg-black opacity-80 z-50"
        @click="closable && emit('input', false)"
      />
    </transition>
    <template v-if="popType === POP_TYPE.CENTER">
      <transition name="fade">
        <div v-if="value" class="center-pop">
          <div class="w-full sticky">
            <slot />
          </div>
        </div>
      </transition>
    </template>
    <template v-else>
      <transition name="slide">
        <div v-if="value" class="fixed-popup z-50">
          <div class="w-full sticky bottom-0">
            <slot />
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(100%);
}

@media (min-width: 768px) {
  .slide-enter,
  .slide-leave-to {
    transform: translateX(-50%) translateY(100%);
  }
}
.center-pop {
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 50;
}

.fixed-popup {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
}

/* stylelint-disable unit-case */
@media (min-width: 768px) {
  .fixed-popup {
    left: 50%;
    right: auto;
    width: 750PX;
    max-width: 750PX;
    transform: translateX(-50%);
  }
}
</style>
